import http from '~/common/http'

export default {
  // 获取活动分享列表
  getList(params) {
    return http.get('/api/sales-leads/share-manage', {
      params: params
    });
  },
  
  // 导出Excel
  exportExcel(params) {
    return http.get('/api/sales-leads/share-manage-export', {
      params: params,
      responseType: 'blob'
    });
  }
}




// WEBPACK FOOTER //
// ./src/services/ShareManage.js